import useHistoricBondCreateBase from "./useHistoricBondCreateBase";
import { PROBATE_HISTORIC_CREATE_CONFIG } from "./historicBondCreateConfig";

function useProbateBondCreateHistoric() {
  const {
    globalState,
    errors,
    setErrors,
    supportModalOpen,
    setSupportModalOpen,
    submissionError,
    isLoading,
    handleSubmit,
    updateGlobalState,
    handleSupportRequestSubmit,
  } = useHistoricBondCreateBase(PROBATE_HISTORIC_CREATE_CONFIG);

  return {
    globalState,
    errors,
    setErrors,
    supportModalOpen,
    setSupportModalOpen,
    submissionError,
    isLoading,
    handleSubmit,
    updateGlobalState,
    handleSupportRequestSubmit,
  };
}

export default useProbateBondCreateHistoric;
